"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.requestPrices = exports.formatPrices = void 0;
const monda_1 = require("@simplisafe/monda");
const fluture_1 = require("fluture");
const isomorphic_fetch_1 = __importDefault(require("isomorphic-fetch"));
const monet_1 = require("monet");
const locale_1 = require("../commercetools/locale");
const perimeterX_1 = __importDefault(require("../perimeterX"));
const price_1 = require("../secrets/price");
const errorLogging_1 = require("../thirdparty/errorLogging");
const fluture_utils_1 = require("../utils/fluture-utils");
const formatPrices = (prices) => prices.reduce((map, price) => ({
    ...map,
    [price.sku]: price
}), {});
exports.formatPrices = formatPrices;
const requestPrices = (skus, userAttributes, customerGroup, forceBucket, partnerName, extraHeaders = {}) => (handleFailure) => (handleSuccess) => {
    const fetchOptions = {
        headers: {
            'Accept': 'application/json',
            'Accept-Language': locale_1.LOCALE,
            'x-opt-device': `${userAttributes.device}`,
            'x-opt-env': `${userAttributes.environment}`,
            'x-opt-firstSeenUrl': `${userAttributes.firstSeenUrl}`,
            'x-opt-isLoggedIn': `${userAttributes.isLoggedIn}`,
            'x-opt-platform': `${userAttributes.platform}`,
            ...extraHeaders
        }
    };
    const experimentKey = monet_1.Maybe.fromUndefined(forceBucket).chain((0, monda_1.safeProp)('experimentKey'))
        .orUndefined();
    const variationKey = monet_1.Maybe.fromUndefined(forceBucket).chain((0, monda_1.safeProp)('variationKey'))
        .orUndefined();
    const searchParams = new URLSearchParams();
    skus.forEach(sku => searchParams.append('skus', sku));
    customerGroup && searchParams.append('customerGroup', customerGroup);
    partnerName && searchParams.append('partnerName', partnerName);
    experimentKey && searchParams.append('experiment', experimentKey);
    variationKey && searchParams.append('variation', variationKey);
    const url = `${price_1.priceUrl}?${searchParams.toString()}`;
    return (0, fluture_1.attemptP)(() => (0, isomorphic_fetch_1.default)(url, fetchOptions))
        .pipe(fluture_utils_1.verifyResponse)
        .pipe((0, fluture_1.chain)(fluture_utils_1.attemptBody))
        .pipe((0, fluture_1.map)(exports.formatPrices))
        .pipe((0, fluture_1.map)(monet_1.Maybe.fromNull))
        .pipe((0, fluture_1.chainRej)(perimeterX_1.default))
        .pipe((0, fluture_1.fork)((e) => {
        (0, errorLogging_1.logError)(e);
        handleFailure(e);
    })(handleSuccess));
};
exports.requestPrices = requestPrices;
//# sourceMappingURL=service.js.map